module.exports = __webpack_public_path__ + "static/media/sz.5419df5b.svg";